module.exports = __webpack_public_path__ + "static/media/767JosephE.BooneBlvdNW_2018-06-11_161.283f4097.jpg";